import { Button, ButtonProps } from '@mantine/core'
import { ReactNode } from 'react'
import { useFormContext } from 'react-hook-form'
import { IconType } from 'react-icons'

interface InputSubmitProps extends ButtonProps {
  value: string | ReactNode
  icon?: IconType
  leftIcon?: ReactNode
  uppercase?: boolean
  disabled?: boolean
}

export const InputSubmit = ({
  value = 'Wyślij',
  icon: Icon,
  leftIcon,
  leftSection,
  uppercase: _uppercase,
  disabled = false,
  mt,
  ...props
}: InputSubmitProps) => {
  const { formState } = useFormContext()
  const { isSubmitting } = formState

  return (
    <Button
      type="submit"
      loading={isSubmitting}
      leftSection={
        leftSection ?? leftIcon ?? (Icon ? <Icon size={'1.2em'} /> : null)
      }
      disabled={disabled}
      mt={mt ?? 'md'}
      {...props}
    >
      {value}
    </Button>
  )
}
